export default String.raw`
<g id="9">
    <rect width="696" height="418" rx="12" class="bgColor" />
    <g id="Header">
        <image x="0" y="0" clip-path="inset(0% round 12px 0 0 12px)" preserveAspectRatio="xMidYMid slice" width="348" height="418" href="./img/previewElements/popupBannerDesktop-1.png" />
    </g>
    <g>
        <g id="Frame 675">
            <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="24" font-weight="500" letter-spacing="0px"><tspan x="372" y="56.7273">TRANSLATION_Prv_PopupBanner_Title</tspan></text>
            <g id="Icon Close">
                <use class="bgColorFont" transform="translate(648, 24)" href="#times" width="24" height="24"></use>
            </g>
        </g>
        <g id="Frame 676" class="primaryColorFont">
            <text xml:space="preserve" style="white-space: pre" font-size="16" font-weight="500" letter-spacing="0px"><tspan x="372" y="121.818">TRANSLATION_Prv_PopupBanner_SecondText_PartA</tspan><tspan x="372" y="141.818">TRANSLATION_Prv_PopupBanner_SecondText_PartB</tspan></text>
            <text xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="372" y="174.364">TRANSLATION_Prv_PopupBannerA_SecondText_PartA</tspan><tspan x="372" y="190.364">TRANSLATION_Prv_PopupBannerA_SecondText_PartB</tspan><tspan x="372" y="206.364">TRANSLATION_Prv_PopupBannerA_SecondText_PartC</tspan><tspan x="372" y="222.364">TRANSLATION_Prv_PopupBannerA_SecondText_PartD</tspan><tspan x="372" y="238.364">TRANSLATION_Prv_PopupBannerA_SecondText_PartE</tspan></text>
        </g>
        <g id="Primary button">
            <rect x="372" y="350" width="300" height="36" rx="5" class="btnSolidBgColor"/>
            <text class="btnSolidTextColor" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="492.264" y="373.091">TRANSLATION_Prv_Check</tspan></text>
        </g>
    </g>
</g>
`;